// Angular
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

// Afidium
import { WORDING } from './config/wording';
import { IBreadcrumbItem } from 'libraries/service/breadcrumb/IBreadcrumbItem';
import { INotification, NotificationType } from 'libraries/interfaces/INotification';

@Component({
    selector: 'processing-validation',
    template: `
        <div class="folder-number">
            <h1>{{ wording.currentFolder }} {{ selectedCodeBooking }}</h1>
            <div>
                <btn
                    [label]="wording.previousFolder"
                    type="actionLink"
                    (onClick)="previousFolder()"
                    [disableIf]="syscodeIndex === 0"></btn>
                <b class="sep-right">{{ syscodeIndex + 1 }} / {{ syscodesLength }}</b>
                <btn
                    [label]="wording.nextFolder"
                    type="actionLink"
                    (click)="nextFolder()"
                    [disableIf]="syscodeIndex === syscodesLength - 1"></btn>
            </div>
        </div>

        <hr class="sep-top">

        <ng-content></ng-content>
    `,
    styles: [`
        notification.sep-top {
            display: block;
        }

        .folder-number {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .link.sep-right {
            display: inline-block;
        }

        .mail-value {
            font-weight: bold;
        }

        hr {
            border: 0;
            background-color: #e4e4e4;
        }
    `]
})
export class ProcessingValidationComponent implements OnInit {
    @Input()
    public syscodes: string[] = [];

    @Input()
    public codes: string[] = [];

    @Output()
    public onChangeFolder: EventEmitter<string> = new EventEmitter();

    public wording = WORDING;

    public syscodeIndex: number = 0;
    public codeBookingIndex: number = 0;
    public syscodesLength: number = 1;

    public selectedCodeBooking: string;
    public breadcrumbItems: IBreadcrumbItem[] = [];
    public notification: INotification = {
        active: false,
        type: NotificationType.Error,
        message: null
    };
    public loader: {
        active: boolean;
        message: string;
    } = {
            active: false,
            message: null
        };

    public ngOnInit(): void {
        this.selectedCodeBooking = this.codes[0];
        this.syscodesLength = this.syscodes.length;

        this.loader = {
            active: true,
            message: this.wording.loadingEmail
        };
    }

    public validationMessageView(): void {
        this.loader = {
            active: true,
            message: this.wording.loadingSendEmail
        };
    }

    public previousFolder(): void {
        this.notification.active = false;
        this.loader.active = true;

        if (this.syscodeIndex > 0) {
            this.codeBookingIndex = this.syscodeIndex = this.syscodeIndex - 1;
            this.changeFolder();
        }
    }

    public nextFolder(): void {
        this.notification.active = false;
        this.loader.active = true;

        if (this.syscodeIndex < this.syscodesLength - 1) {
            this.codeBookingIndex = this.syscodeIndex = this.syscodeIndex + 1;
            this.changeFolder();
        }
    }

    private changeFolder(): void {
        const xCodeBooking = this.codes[this.codeBookingIndex];
        const syscode = this.syscodes[this.syscodeIndex];

        if (syscode) {
            this.selectedCodeBooking = xCodeBooking;
            this.onChangeFolder.emit(syscode);
        }
    }
}
